import { makeAutoObservable } from "mobx";
import { NodeId } from "./node";

/**
 * Раскрытые ветви дерева.
 *
 * Вынесено из TreeStore: там это была третья ответственность, и файл упёрся
 * в предел размера. Связь осталась одна — при удалении узла дерево просит
 * забыть его раскрытие.
 */
export class ExpansionStore {
  constructor() {
    makeAutoObservable(this);
  }

  private readonly ids = new Set<NodeId>();

  get keys(): NodeId[] {
    return Array.from(this.ids);
  }

  isExpanded(id: NodeId): boolean {
    return this.ids.has(id);
  }

  set(id: NodeId, expanded: boolean) {
    if (expanded) this.ids.add(id);
    else this.ids.delete(id);
  }

  clear() {
    this.ids.clear();
  }

  forget(ids: readonly NodeId[]) {
    ids.forEach((id) => this.ids.delete(id));
  }
}
